import "./textCopy";
import "../scss/app.scss";
import "./changeSelectColor";
import "./creditSelectForm";
import "./notificationClose";
import "./modalToggle";
import "./modalToggleCenter";
import "./rich/richTemp";
import "./rich/linkSelect";
import "./rich/menuChange";
import "./enquete/addChoiceForm";
import "./slideToggleForm";
import "./inputAllCheckBox";
import "./reply/datepicker.js";
import "./formAdd/formAdd";
import "./formAdd/formDelete";
import "./doubleForm";
import "./drop";
import "./rich/dropRich";
import "./readerChart";
import "./placeholder";
import "./talk/sortName";
import "./talk/torkStatus";
import "./talk/torkSearch";
import "./talk/send";
import "./talk/info-memo";
import "./talk/info-tag";
import "./talk/file";
import "./talk/name";
//import "./mailListvalidation";
